// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const AuditEntryDetail = zod.object({
  "action": zod.string(),
  "actor_display": zod.string(),
  "actor_role_at_time": zod.union([zod.string(),zod.null()]),
  "actor_user_id": zod.union([zod.uuid(),zod.null()]),
  "after_value": zod.union([zod.unknown(),zod.null()]),
  "before_value": zod.union([zod.unknown(),zod.null()]),
  "context": zod.union([zod.unknown(),zod.null()]),
  "entity_id": zod.union([zod.string(),zod.null()]),
  "entity_type": zod.union([zod.string(),zod.null()]),
  "event_family": zod.string(),
  "http_method": zod.string(),
  "id": zod.uuid(),
  "occurred_at": zod.iso.datetime({"offset":true}),
  "outcome": zod.string(),
  "reason": zod.union([zod.string(),zod.null()]),
  "request_id": zod.union([zod.string(),zod.null()]),
  "route_template": zod.string(),
  "source_ip": zod.union([zod.string(),zod.null()]),
  "status_code": zod.union([zod.int(),zod.null()]),
  "user_agent": zod.union([zod.string(),zod.null()]),
  "via": zod.union([zod.string(),zod.null()]).optional()
});

export type AuditEntryDetail = zod.input<typeof AuditEntryDetail>;
export type AuditEntryDetailOutput = zod.output<typeof AuditEntryDetail>;
